import type { AppDispatch } from '../../store'
import { createConfiguration } from '../../global-state/investor-slice'
import type { AccountStatus } from '../types'

export type EmailVerificationLoginPayload = {
  authToken: string
  userId: number
  name: string
  email: string
  role: string
  isEmailVerified?: boolean
  acceptedNDA?: boolean
  kycStatus?: string
  account_status?: AccountStatus
  mustSetPassword?: boolean
}

export type VerifyEmailErrorData = {
  message?: string
  code?: string
}

export const isEmailVerificationLoginData = (
  data: unknown,
): data is EmailVerificationLoginPayload => {
  return (
    typeof data === 'object' &&
    data !== null &&
    'authToken' in data &&
    typeof (data as EmailVerificationLoginPayload).authToken === 'string'
  )
}

export const getVerifyEmailError = (data: unknown): VerifyEmailErrorData | null => {
  if (isEmailVerificationLoginData(data)) return null
  if (typeof data === 'object' && data !== null) {
    return data as VerifyEmailErrorData
  }
  return null
}

export const completeEmailVerificationLogin = (
  dispatch: AppDispatch,
  payload: EmailVerificationLoginPayload,
): void => {
  dispatch(
    createConfiguration({
      authToken: payload.authToken,
      userId: payload.userId,
      name: payload.name,
      email: payload.email,
      role: payload.role,
      isEmailVerified: true,
      acceptedNDA: payload.acceptedNDA ?? false,
      kycStatus: payload.kycStatus ?? '',
      ...(payload.account_status ? { accountStatus: payload.account_status } : {}),
    }),
  )
}
